import { gql } from '@apollo/client';

export const ALL_ZONES_QUERY_NAME = 'AllZones';
export const ALL_ZONES = gql`
    query ${ALL_ZONES_QUERY_NAME}(
        $page: Int, 
        $perPage: Int,
        $sortKey: String,
        $sortDirection: String,
        $includeDeactivated: Boolean,
        $valueMapping: Map_String_List_MappedValueScalar,
    ) {
        allZones(
            page: $page, 
            perPage: $perPage,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
            includeDeactivated: $includeDeactivated,
            valueMapping: $valueMapping,
        ) {
            availableClearingHouses {
                name
                code
            }
            availableCurrencies {
                name
                code
            }
            zoneList {
                totalCount
                models {
                    id
                    code
                    name
                    flagCode
                    active
                    modificationBlockers
                    deactivationBlockers
                    currency {
                        code
                    },
                    clearingHouse {
                        code
                    }
                    assignedMembers {
                        memberId
                        name
                    }
                    assignedUsers {
                        racf
                        userCode
                        name
                    }
                }
            }
        }
    }
`;

export const CREATE_ZONE = gql`
    mutation CreateZone(
        $name: String!,
        $code: String!,
        $clearingHouseCode: String!,
        $currencyCode: String!,
        $flagCode: String,
        $correlationId: String!
    ) {
        createZone(
            name: $name,
            code: $code,
            clearingHouseCode: $clearingHouseCode,
            currencyCode: $currencyCode,
            flagCode: $flagCode,
            correlationId: $correlationId
        ) {
            name
            code
        }
    }
`;

export const UPDATE_ZONE = gql`
    mutation UpdateZone(
        $id: Int!,
        $name: String!,
        $code: String!,
        $clearingHouseCode: String!,
        $currencyCode: String!,
        $flagCode: String,
        $fourEyesUserId: String,
        $fourEyesPassword: String,
        $correlationId: String!
    ) {
        updateZone(
            id: $id,
            name: $name,
            code: $code,
            clearingHouseCode: $clearingHouseCode,
            currencyCode: $currencyCode,
            flagCode: $flagCode,
            fourEyesUserId: $fourEyesUserId,
            fourEyesPassword: $fourEyesPassword,
            correlationId: $correlationId
        ) {
            name
            code
        }
    }
`;

export const ON_ZONE_CHANGE = gql`
    subscription onZoneChanged {
        zoneChanged {
            correlationId
            action
            model {
                name
                code
            }
        }
    }
`;

export const TOGGLE_ZONE_ACTIVATION = gql`
    mutation ToggleZoneActivation(
        $id: Int!,
        $fourEyesUserId: String,
        $fourEyesPassword: String,
        $correlationId: String!
    ) {
        toggleZoneActivation(
            id: $id,
            fourEyesUserId: $fourEyesUserId,
            fourEyesPassword: $fourEyesPassword,
            correlationId: $correlationId
        ) {
            name
            code
            active
        }
    }
`;
